import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Icon from '../utils/icon';

const useStyles = makeStyles((theme) => ({
  cardcontenttype: {
    backgroundColor: theme.palette.primary.highlight,
    padding: theme.spacing(0, 1.25),
    borderRadius: theme.spacing(2),
    color: '#fff',
    fontWeight: 600,
    letterSpacing: 1,
    fontSize: '0.6rem'
  }
}));

const listCategories = (categoriesitem) => {
  return categoriesitem?.slice(0, 2).map((item, index) => {
    return (
      <Box
        key={index}
        width={32}
        height={32}
        borderRadius={16}
        className={item.taxItemName_s}
        display='flex'
        alignItems='center'
        justifyContent='center'
        ml={1}
      >
        <Icon
          name={item.taxItemName_s}
          color='#ffffff'
          widthsize={23}
          heightsize={23}
        />
      </Box>
    );
  });
};

export default function CardHeader(props) {
  const classes = useStyles();
  return (
    <Box
      width={1}
      px={1}
      py={props.contenttype ? 0.75 : 0}
      display='flex'
      justifyContent='space-between'
      alignItems='center'
      height={props.contenttype ? 48 : 0}
    >
      <Typography
        variant='overline'
        className={classes.cardcontenttype + ' line-clamp-1'}
      >
        {props.contenttype}
      </Typography>
      <Box display='flex'>{listCategories(props.categories)}</Box>
    </Box>
  );
}
